import * as React from 'react';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import {
    StyledWrapper,
    StyledContent,
    StyledModal,
    StyledHeader,
    StyledIcon,
    StyledFooter,
    StyledTitle,
} from '@process-advisor/process-miner/components/modal/modal.styles'
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { Event } from '@process-advisor/process-miner/api/events';
import styled from 'styled-components';
import { TaskDetail} from '@process-advisor/process-miner/modals/detail/taskDetail/taskDetail'

const Detail = styled.div`
    width: 1200px;
    height: 650px;
    border: hidden;
    canvas {
        outline: none;
    };
`;

type Props = {
    props: {
        param: string,
    },
}

export type Data = []

export const TaskDetailModal: React.FC = () => {
    const [props, setProps] = React.useState<{  param: string}>({ param: ''});
    const [open, setOpen] = React.useState(false);
    const [title, setTitle] = React.useState('');
    const [showCloseIcon, setShowCloseIcon] = React.useState(true);
    const [showButtons, setShowButtons] = React.useState(true);

    function onClose() {
        setOpen(false)
    }
    useApiListener(
        Event.openTaskDetailModal,
        ({ props }: Props) => {
            setOpen(true);
            setProps(props);
        }
    );

    React.useEffect(() => {
        setTitle(apiProvider.getEntityUpper() + ' Detail')
    }, [open]);

    return (
        <StyledWrapper open={open} onClose={onClose}>
            <StyledModal >
                <StyledHeader>
                    <StyledTitle>{title}</StyledTitle>
                    {showCloseIcon ? <StyledIcon onClick={onClose} /> : <div />}
                </StyledHeader>
                <StyledContent>
                    <Detail>
                        <TaskDetail/>
                    </Detail>
                </StyledContent>
                <StyledFooter>
                    <Button label='Close' onClick={onClose} disabled={false} />
                </StyledFooter>
            </StyledModal>
        </StyledWrapper>
    );
};

